export default __webpack_public_path__ + "static/media/Scandinavian.2a17d3f2.jpg";